import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Table, Spin } from "antd";

import ExperienceRow from "./ExperienceRow";
import InsuranceUploader from "./InsuranceUploader";
import useWorkExperienceData from "../../../../../custom-hooks/useWorkExperienceData";
import { getRequest } from "../../../../../api/http";
import userServiceApi from "../../../../../api/userServiceApi";
import { toast } from "react-toastify";
import "./WorkExperience.scss";

export default function WorkExperienceNew() {
  const { micrositeId } = useParams();
  const {
    finalData,
    setFinalData,
    loader,
    uploadProps,
    existingFiles,
    handleDeleteFile,
  } = useWorkExperienceData(micrositeId);
  const [eofOpportunityTitle, setEofOpportunityTitle] = useState(null);

  const getEofOpportunityTitles = async () => {
    try {
      const response = await getRequest(
        userServiceApi.getMasterDataType("WORK_OPPORTUNITY_TITLE")
      );
      if (response) {
        setEofOpportunityTitle(response);
      }
    } catch (error) {
      toast.error(error.error);
    }
  };

  useEffect(() => {
    getEofOpportunityTitles();
  }, [micrositeId]);

  if (loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  }

  const columns = [
    {
      title: "",
      dataIndex: "experienceOfWorkTitle",
      key: "experienceOfWorkID",
      render: (value) => <b>{value}</b>,
    },
    {
      title: "Virtual Opportunities",
      dataIndex: "virtual",
      key: "virtual",
      className: "table-headers",
      render: (_, record, index) => (
        <ExperienceRow
          record={record}
          index={index}
          type="VIRTUAL"
          key={`virtual-${index}`}
          finalData={finalData}
          setFinalData={setFinalData}
          eofOpportunityTitle={eofOpportunityTitle}
        />
      ),
    },
    {
      title: "Face to Face Opportunities",
      dataIndex: "faceToFace",
      key: "faceToFace",
      className: "table-headers",
      render: (_, record, index) => (
        <ExperienceRow
          record={record}
          index={index}
          type="FACE_TO_FACE"
          key={`face-${index}`}
          finalData={finalData}
          setFinalData={setFinalData}
          eofOpportunityTitle={eofOpportunityTitle}
        />
      ),
    },
  ];

  return (
    <div>
      <InsuranceUploader
        uploadProps={uploadProps}
        existingFiles={existingFiles}
        handleDeleteFile={handleDeleteFile}
      />
      <Table
        pagination={false}
        columns={columns}
        dataSource={finalData}
        rowKey="experienceOfWorkID"
      />
    </div>
  );
}
